


// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { BsArrowRight } from "react-icons/bs";

// const SpecialOffer = () => {
//   return (
//     <section className="container my-5">
//       {/* Desktop Layout */}
//       <div className="row align-items-center justify-content-center position-relative d-none d-md-flex">
//         {/* Left Image */}
//         <div className="col-md-5 p-0 me-md-2">
//           <img
//             src="https://modavenextjs.vercel.app/images/banner/banner-w-text1.jpg"
//             alt="Left"
//             className="img-fluid w-100"
//             style={{ objectFit: "cover", height: "100%", marginRight: "80px" }}
//           />
//         </div>

//         {/* Right Image */}
//         <div className="col-md-5 p-0 ms-md-3">
//           <img
//             src="https://modavenextjs.vercel.app/images/banner/banner-w-text2.jpg"
//             alt="Right"
//             className="img-fluid w-100"
//             style={{ objectFit: "cover", height: "100%", marginLeft: "100px" }}
//           />
//         </div>

//         {/* Center White Box */}
//         <div className="col-md-4 text-center bg-white p-5 position-absolute top-50 start-50 translate-middle shadow-sm">
//           <h2 className="fw-bold mb-3">
//             Special Offer! <br /> This Week Only
//           </h2>
//           <p className="text-muted mb-4">Reserved for special occasions</p>
//           <button className="btn btn-dark px-4 py-2 rounded-pill d-flex align-items-center mx-auto">
//             Explore Collection <BsArrowRight className="ms-2" />
//           </button>
//         </div>
//       </div>

//       {/* Mobile Layout */}
//       <div className="d-flex flex-column d-md-none text-center gap-3">
//         {/* Left Image */}
//         <img
//           src="https://modavenextjs.vercel.app/images/banner/banner-w-text1.jpg"
//           alt="Left"
//           className="img-fluid w-100"
//           style={{ objectFit: "cover" }}
//         />

//         {/* Center Text */}
//         <div className="bg-white p-4 shadow-sm">
//           <h2 className="fw-bold mb-3">
//             Special Offer! <br /> This Week Only
//           </h2>
//           <p className="text-muted mb-4">Reserved for special occasions</p>
//           <button className="btn btn-dark px-4 py-2 rounded-pill d-flex align-items-center mx-auto">
//             Explore Collection <BsArrowRight className="ms-2" />
//           </button>
//         </div>

//         {/* Right Image */}
//         <img
//           src="https://modavenextjs.vercel.app/images/banner/banner-w-text2.jpg"
//           alt="Right"
//           className="img-fluid w-100"
//           style={{ objectFit: "cover" }}
//         />
//       </div>
//     </section>
//   );
// };

// export default SpecialOffer;
import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const SpecialOffer = () => {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/shop`);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.disconnect(); 
          }
        });
      },
      { threshold: 0.2 } 
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section   className="container special-offer-section"
 ref={sectionRef}      >
   
    
      <style>
        {`
          @keyframes slideInLeft {
            from { transform: translateX(-150px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          @keyframes slideInRight {
            from { transform: translateX(150px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          @keyframes zoomIn {
            from { transform: scale(0.5); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
          .slide-in-left {
            animation: slideInLeft 1s ease-out forwards;
          }
          .slide-in-right {
            animation: slideInRight 1s ease-out forwards;
          }
          .zoom-in {
            animation: zoomIn 1s ease-out forwards;
            animation-delay: 0.3s;
          }
          .special-offer-section {
  margin-top: -150px !important; /* Pull the section up on desktop */
}

@media (max-width: 767px) {
  .special-offer-section {
    margin-top: 0 !important; /* Reset on mobile */
  }
}

        `}
      </style>

      {/* Desktop Layout */}
      {/* <div className="row align-items-center justify-content-center position-relative d-none d-md-flex">
    
        <div
          className={`col-md-5 p-0 me-md-2 ${inView ? "slide-in-left" : ""}`}
        >
          <img
            src="https://modavenextjs.vercel.app/images/banner/banner-w-text1.jpg"
            alt="Left"
            className="img-fluid w-100"
               style={{ objectFit: "cover", height: "100%", marginRight: "100px"}}
          />
        </div>

     
        <div
          className={`col-md-5 p-0 ms-md-3 ${inView ? "slide-in-right" : ""}`}
        >
          <img
            src="https://modavenextjs.vercel.app/images/banner/banner-w-text2.jpg"
            alt="Right"
            className="img-fluid w-100"
        style={{ objectFit: "cover", height: "100%", marginLeft: "100px", }}
          />
        </div>

     
        <div
          className={`col-md-4 text-center bg-white p-5 position-absolute top-50 start-50 translate-middle shadow-sm ${
            inView ? "zoom-in" : ""
          }`}
        >
          <h2 className="fw-bold mb-3">
            Special Offer! <br /> This Week Only
          </h2>
          <p className="text-muted mb-4">Reserved for special occasions</p>
          <button className="btn btn-dark px-4 py-2 rounded-pill d-flex align-items-center mx-auto">
            Explore Collection <BsArrowRight className="ms-2" />
          </button>
        </div>
      </div> */}
<div className="row align-items-center justify-content-center position-relative d-none d-md-flex">
  
<div
  className={`col-md-5 p-0 ${inView ? "slide-in-left" : ""}`}
  style={{ marginLeft: "-90px" }} 
>
  <img
    src="https://myheartbeets.com/wp-content/uploads/2016/08/Indian-Spices.jpg"
    alt="Left"
    className="img-fluid w-100"
    style={{ objectFit: "cover",      }}
  />
</div>


  <div
    className={`col-md-5 p-0 ${inView ? "slide-in-right" : ""}`}
    style={{ overflow: "visible" }}
  >
    <img
      src="https://5.imimg.com/data5/SELLER/Default/2025/3/496255234/FZ/ZO/MS/242846722/roasted-coffee-beans.jpg"
      alt="Right"
      className="img-fluid"
      style={{
        objectFit: "cover",
     height: "440px", 
        width: "110%",      
        marginLeft: "150px" ,
         marginTop: "160px" 
         
      }}
    />
  </div>

  <div
    className={`col-md-4 text-center bg-white p-5 position-absolute top-50 start-50 translate-middle shadow-sm ${
      inView ? "zoom-in" : ""
    }`}
     style={{ zIndex: 2, marginTop: "100px", maxWidth: "350px" ,maxHeight:'300px' }} 
  >
    <h7 className="fw-bold mb-3">
   Experience the true taste of Wayanad through every <br />handcrafted product we offer.
    </h7>
    <p className="text-muted mb-4">Reserved for special occasions</p>
    <button className="btn btn-dark px-4 py-2 rounded-pill d-flex align-items-center mx-auto"  style={{backgroundColor:'#1C3F1D'}} onClick={handleClick}>
      Explore Collection <BsArrowRight className="ms-2"/>
    </button>
  </div>
</div>

      <div className="d-flex flex-column d-md-none text-center gap-3">
     
        <img
          src="https://myheartbeets.com/wp-content/uploads/2016/08/Indian-Spices.jpg"
          alt="Left"
          className={`img-fluid w-100 ${inView ? "slide-in-left" : ""}`}
          style={{ objectFit: "cover" }}
        />

 
        <div
          className={`bg-white p-4 shadow-sm ${inView ? "zoom-in" : ""}`}
        >
          <h7 className="fw-bold mb-3">
            Experience the true taste of Wayanad through every <br />handcrafted product we offer.
          </h7>
          <p className="text-muted mb-4">Reserved for special occasions</p>
          <button className="btn btn-dark px-4 py-2 rounded-pill d-flex align-items-center mx-auto" onClick={handleClick}>
            Explore Collection <BsArrowRight className="ms-2" />
          </button>
        </div>


        <img
          src="https://5.imimg.com/data5/SELLER/Default/2025/3/496255234/FZ/ZO/MS/242846722/roasted-coffee-beans.jpg"
          alt="Right"
          className={`img-fluid w-100 ${inView ? "slide-in-right" : ""}`}
          style={{ objectFit: "cover" }}
        />
      </div>
    </section>
  );
};

export default SpecialOffer;
